// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Users Page - Tavern Theme */

.users-page {
  /* background inherited from body wood texture */
}

.users-page .ttbPageTitle {
  color: var(--color-fire-500);
  font-family: var(--font-heading);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  border-bottom: 2px solid var(--color-fire-600);
  padding-bottom: var(--space-3);
  margin-bottom: var(--space-6);
}

/* Search and key filters */
.users-filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.users-key-filter {
  min-height: 44px;
  padding: var(--space-2) var(--space-4);
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  background: var(--color-parchment-100);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background var(--transition-fast),
    border-color var(--transition-fast),
    box-shadow var(--transition-fast);
}

.users-key-filter--active {
  border-color: var(--color-fire-600);
  background: linear-gradient(135deg, #9a5a24, #6b3518);
  color: var(--color-parchment-100);
  box-shadow: 0 2px 6px rgba(107, 53, 24, 0.35);
}

.users-key-filter:focus-visible {
  outline: 3px solid var(--tg-theme-link-color, #2481cc);
  outline-offset: 2px;
}

@media (max-width: 480px) {
  .users-filters {
    grid-template-columns: 1fr;
  }

  .users-key-filter {
    width: 100%;
  }
}

/* Users list */
.users-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* Error state */
.users-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4);
}

/* Load more button */
.users-load-more {
  margin-top: var(--space-4);
}

@media (min-width: 768px) {
  .users-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}

@media (min-width: 1024px) {
  .users-list {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Users/UsersPage.css"],"names":[],"mappings":"AAEA,8BAA8B;;AAE9B;EACE,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,2CAA2C;EAC3C,8CAA8C;EAC9C,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;;qCAGmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,qDAAqD;EACrD,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF","sourcesContent":["@import '../_base.css';\n\n/* Users Page - Tavern Theme */\n\n.users-page {\n  /* background inherited from body wood texture */\n}\n\n.users-page .ttbPageTitle {\n  color: var(--color-fire-500);\n  font-family: var(--font-heading);\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n  border-bottom: 2px solid var(--color-fire-600);\n  padding-bottom: var(--space-3);\n  margin-bottom: var(--space-6);\n}\n\n/* Search and key filters */\n.users-filters {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.users-key-filter {\n  min-height: 44px;\n  padding: var(--space-2) var(--space-4);\n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  background: var(--color-parchment-100);\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    background var(--transition-fast),\n    border-color var(--transition-fast),\n    box-shadow var(--transition-fast);\n}\n\n.users-key-filter--active {\n  border-color: var(--color-fire-600);\n  background: linear-gradient(135deg, #9a5a24, #6b3518);\n  color: var(--color-parchment-100);\n  box-shadow: 0 2px 6px rgba(107, 53, 24, 0.35);\n}\n\n.users-key-filter:focus-visible {\n  outline: 3px solid var(--tg-theme-link-color, #2481cc);\n  outline-offset: 2px;\n}\n\n@media (max-width: 480px) {\n  .users-filters {\n    grid-template-columns: 1fr;\n  }\n\n  .users-key-filter {\n    width: 100%;\n  }\n}\n\n/* Users list */\n.users-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n/* Error state */\n.users-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-4);\n}\n\n/* Load more button */\n.users-load-more {\n  margin-top: var(--space-4);\n}\n\n@media (min-width: 768px) {\n  .users-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n}\n\n@media (min-width: 1024px) {\n  .users-list {\n    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
